import * as z from "zod";

export const BrandStatusEnum = z.enum(["active", "inactive", "draft"]);

export const BrandSchema = z.object({
  id: z.string().uuid(),
  name: z
    .string()
    .min(1, "Name is required")
    .max(255, "Name must be less than 255 characters")
    .trim(),
  description: z
    .string()
    .max(255, "Description must be less than 255 characters")
    .nullable()
    .optional(),
  website: z.string().url("Must be a valid URL").nullable().optional(),
  logo: z.string().url("Must be a valid URL").nullable().optional(),
  status: BrandStatusEnum.default("draft"),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createBrandSchema = BrandSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateBrandSchema = BrandSchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});
